module.exports = __webpack_public_path__ + "img/hand.cf60e393.svg";